import api from './api'

export const variantImagesService = {
  uploadImages: (variantId, formData) => {
    console.log('Upload d\'images pour la variante:', variantId, formData);
    return api.post(`/api/product-variants/${variantId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  deleteImage: (imageId) => {
    console.log('Suppression de l\'image:', imageId);
    console.log('URL de l\'API:', `/api/variant-images/${imageId}`);
    return api.delete(`/api/variant-images/${imageId}`);
  },
  
  setPrimaryImage: (imageId) => {
    console.log('Définition de l\'image primaire:', imageId);
    return api.put(`/api/variant-images/${imageId}/set-primary`);
  },
  
  reorderImages: (imageIds) => {
    console.log('Réorganisation des images:', imageIds);
    return api.put('/api/variant-images/reorder', { imageIds });
  }
}
